import React, { useCallback, useContext, useMemo } from 'react';
import { EntityClick } from '../WidgetComponent/types';

export const ClickActionContext = React.createContext<{ onEntityClick?: EntityClick }>(null);
export function useClickActionContext() {
    const context = useContext<{ onEntityClick?: EntityClick }>(ClickActionContext);
    if (!context) {
        throw new Error('ClickActionContext must be used within a ClickActionContextProvider');
    }
    return context;
}

export const ClickActionContextProvider = ({ children, value }) => {
    const handleEntityClick = useCallback(
        args => {
            if (value?.onEntityClick) {
                value.onEntityClick(args);
            }
        },
        [value]
    );
    const resolvedValue = useMemo(
        () => ({
            ...value,
            onEntityClick: handleEntityClick,
        }),
        [value, handleEntityClick]
    );
    return (
        <ClickActionContext.Provider value={resolvedValue}>{children}</ClickActionContext.Provider>
    );
};
